export default __webpack_public_path__ + "static/media/arrow-expanded.e704653b.svg";